import React from 'react';
import { PropTypes } from 'prop-types';
import { MetaData, Avatar } from 'components/project/ClerkScreen';
import { MessageText, IndividualMessage, GlobalMessage } from './Styles';
import { OnlineIndicator } from '../OnlineIndicator/index';
import { messagePrettier } from './../../../../../stores/utils';
import { LONGEST_VIN_LENGTH } from 'shared/constants';

const ClerkMessage = ({
  children,
  itemNumber,
  user,
  account,
  timestamp,
  avatarUrl,
  handleMetaDataClick,
  zoomLevel,
  chatFontSize,
}) => {
  return (
    <>
      {account ? (
        <IndividualMessage>
          <MessageText zoomLevel={zoomLevel} chatFontSize={chatFontSize}>
            <div>
              <OnlineIndicator user={user} />
            </div>
            {messagePrettier(children, LONGEST_VIN_LENGTH)}
          </MessageText>
          <MetaData
            itemNumber={itemNumber}
            timestamp={timestamp}
            handleMetaDataClick={handleMetaDataClick}
            chatFontSize={chatFontSize}
          />
          <Avatar url={avatarUrl} />
        </IndividualMessage>
      ) : (
        <GlobalMessage>
          <MessageText
            isGlobalMessage
            zoomLevel={zoomLevel}
            chatFontSize={chatFontSize}
          >
            <div>All Lane Bidders</div>
            {messagePrettier(children, LONGEST_VIN_LENGTH)}
          </MessageText>
          <MetaData
            itemNumber={itemNumber}
            timestamp={timestamp}
            handleMetaDataClick={handleMetaDataClick}
            chatFontSize={chatFontSize}
          />
          <Avatar url={avatarUrl} />
        </GlobalMessage>
      )}
    </>
  );
};

ClerkMessage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  itemNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  user: PropTypes.string,
  timestamp: PropTypes.string,
  avatarUrl: PropTypes.string,
  account: PropTypes.string,
  handleMetaDataClick: PropTypes.func.isRequired,
};

ClerkMessage.defaultProps = {
  children: null,
  itemNumber: null,
  user: null,
  timestamp: null,
  avatarUrl: null,
  account: null,
};

export default ClerkMessage;
